import { Component, ViewChild } from '@angular/core';
import { Nav, Platform ,AlertController,ViewController,App} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

 // rootPage: any = HomePage;
 // rootPage: any = LoginPage;
  rootPage:any;
  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform,private alertCtrl: AlertController, public statusBar: StatusBar, public splashScreen: SplashScreen) {
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Start', component: HomePage },
     // { title: 'List', component: ListPage },
    //  { title: 'Login', component: LoginPage },
      {title: 'Logout', component:null}
    ];

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
    //alert(localStorage.getItem('customers_id'));
    if((localStorage.getItem('customers_id') === "undefined"  )|| (localStorage.getItem('customers_id') == null )) {

  
    this.rootPage = LoginPage
  } else {
   this.rootPage = HomePage;
   }
   
  }
  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Wollen Sie wirklich abmelden?',
      buttons: [
        {
          text: 'Abbruch',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
        //  this.nav.remove(index);
          // this.navCtrl.rootNav.setRoot(LoginsignupPage);  
  
           // this.viewCtrl.dismiss();
         //  this.appCtrl.getRootNav().setRoot(LoginPage);
           //this.navCtrl.setRoot(LoginsignupPage);  
           localStorage.clear();
           this.nav.setRoot(LoginPage);
          }
        }
      ]
    });
    alert.present();
  }

  openPage(page) {
    if (page.title === 'Logout') {
      //alert(1212);
      this.presentConfirm();
   
    
    }
    else{
      this.nav.setRoot(page.component);
    }
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
   
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts